import * as React from 'react';

declare const I18n;

import CategoryCard from '../../components/category_card';
import Header from '../../../Header';
import BreadCrumb from '../../../BreadCrumb';
import api from '../../../../api';

type Category = {
  id: number;
  name: string;
  name_fr?: string;
  description?: string;
  description_fr?: string;
};

type Props = {
  initialData: {
    categories: Category[];
    notice?: string;
  };
};

const EditCategories: React.FunctionComponent<Props> = ({
  initialData: { categories, notice },
}: Props): JSX.Element => {
  const [categoryList, setCategoryList] = React.useState(categories || []);

  const categoryLabel = (category: Category): string => {
    if (I18n.locale === 'fr') {
      return category.name_fr || category.name;
    }

    return category.name;
  };

  const categoryDescription = (category: Category): string => {
    if (I18n.locale === 'fr') {
      return category.description_fr || category.description || '';
    }

    return category.description || '';
  };

  const handleDelete = (id: number) => {
    api
      .deleteCategory(id)
      .then((res) => {
        setCategoryList(categoryList.filter((item) => item.id !== id));
        if (res?.url) {
          window.location.href = res.url;
        }
      })
      .catch((error) => {
        const responseError = error?.response?.data?.error;
        if (responseError) {
          alert(responseError);
        } else {
          console.error('Error', error);
        }
      });
  };

  return (
    <div className="courses_index">
      {notice && <div className="header__top-bar alert alert-info">{notice}</div>}

      <Header
        title={I18n.t('models.course.type.edit_category')}
        titleButton={I18n.t('models.course.type.create_category')}
        locationButton="/admin/courses/new_category"
        showIcon={false}
      />

      <BreadCrumb
        locations={[
          { title: I18n.t('models.course.attributes.courses'), url: '/admin/courses' },
          { title: I18n.t('models.course.type.edit_category'), url: null },
        ]}
      />

      <div className="courses_index__section">
        {categoryList.length > 0 ? (
          <div className="category-cards">
            {categoryList.map((row) => (
              <CategoryCard
                key={row.id}
                title={categoryLabel(row)}
                description={categoryDescription(row)}
                id={row.id}
                handleDelete={handleDelete}
              />
            ))}
          </div>
        ) : (
          <div className="courses_index__empty-state app-text">
            {I18n.t('models.course.messaging.category_empty_state')}
          </div>
        )}
      </div>
    </div>
  );
};

export default EditCategories;
